import { server_ip } from "../config";

async function fetchWatchMessages(token,filter={},options={}) {
    try {
        const response = await fetch(`${server_ip}/api/watchMessages/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                "filter":{...filter},
                "options":{"limit":99,...options}
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}

export{
    fetchWatchMessages,
}